<template>
  <b-modal v-model="modal" :title="title" size="lg" :no-enforce-focus="true" :no-close-on-backdrop="true">
    <loading
      :active.sync="loading"
      color="#556ee6"
      loader="dots"
      :can-cancel="false"
      :is-full-page="false">
    </loading>
    <div class="row">
      <div class="col-lg-12">
        <form @submit.prevent="saveSubMenu()" autocomplete="off">
          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <label for="name">Título</label>
                <input
                  id="name"
                  v-model="submenu.name"
                  name="name"
                  type="text"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.submenu.name.$error
                  }"
                />
                <div
                  v-if="submitted && !$v.submenu.name.required"
                  class="invalid-feedback"
                >
                  O campo é obrigatório.
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="link">Link</label>
                <input
                  id="link"
                  v-model="submenu.link"
                  name="link"
                  type="text"
                  class="form-control"
                  :disabled="submenu.module"
                />
                <div
                  v-if="submitted && !$v.submenu.link.url"
                  class="invalid-feedback"
                >
                O campo Link deve ser uma url válida
                </div>
              </div>
            </div>
            <div class="col-sm-2">
              <div class="form-group">
                <label for="icon">Icone</label>
                <input
                  id="icon"
                  v-model="submenu.icon"
                  name="icon"
                  type="text"
                  class="form-control"
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button variant="secondary" @click="close()">Fechar</b-button>
      <button type="submit" class="btn btn-primary mr-1" @click="saveSubMenu()">Salvar</button>
    </template>
  </b-modal>
</template>
<script>
// Import component
import Loading from 'vue-loading-overlay'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'
import { required, url } from 'vuelidate/lib/validators'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    Loading
  },
  data () {
    return {
      title: 'SUB MENU',
      loading: true,
      fullPage: true,
      submitted: false,
      modal: false,
      refId: null,
      submenu: {}
    }
  },
  validations () {
    return {
      submenu: {
        name: { required },
        link: { url }
      }
    }
  },
  computed: {
    ...mapState('menu', { data: 'menu' })
  },
  methods: {
    ...mapActions('menu', {
      fetchItem: 'show',
      postData: 'save'
    }),
    loadItem (id) {
      if (id) {
        this.loading = true
        this.fetchItem(id).then((data) => {
          this.submenu = this.data
        }).then(() => {
          this.loading = false
        })
      }
    },
    open (refId, id = null) {
      this.modal = true
      this.loading = true
      this.refId = refId
      if (id) {
        this.loadItem(id)
        return
      }
      this.loading = false
    },
    async saveSubMenu () {
      this.submitted = true
      this.$v.submenu.$touch()
      if (this.$v.submenu.$invalid) {
        window.scroll(0, 0)
        return
      }
      this.loading = true
      if (!this.submenu.id) {
        this.submenu.ref_id = this.refId
      }
      await this.postData(this.submenu).then(res => {
        let message = 'Sucesso: Dados armazenados com sucesso.'
        let delay = 2500
        successMessage(message, delay)
        this.close()
        this.$emit('update', this.refId)
        this.loading = false
      }).catch((err) => {
        errorMessage('Alerta: ' + err.message)
        this.loading = false
      })
    },
    close () {
      this.modal = false
      this.submenu = {}
      this.$v.$reset()
    }
  },
  watch: {
    modal () {
      if (!this.modal) {
        this.close()
      }
    }
  }
}
</script>
<style scoped>
.mt-15 { margin-top:15px }
.vld-overlay.is-full-page {
    z-index: 1051 !important;
}
</style>
